module.exports = __webpack_public_path__ + "static/img/Group3.167cd1bc.png";